import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelText as _vModelText, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = {
  key: 0,
  class: "alert alert-success d-flex justify-content-between align-items-start py-2 px-3 mb-3"
}
const _hoisted_4 = { class: "small text-muted mt-1" }
const _hoisted_5 = { class: "card card-body mb-3" }
const _hoisted_6 = { class: "text-capitalize-first mb-3" }
const _hoisted_7 = { class: "row g-3" }
const _hoisted_8 = { class: "col-md-12 col-lg-2" }
const _hoisted_9 = { class: "form-label text-capitalize-first" }
const _hoisted_10 = {
  class: "btn-group btn-group-sm w-100",
  role: "group"
}
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  class: "btn btn-outline-primary",
  for: "rates-direction-in"
}
const _hoisted_13 = ["value"]
const _hoisted_14 = {
  class: "btn btn-outline-primary",
  for: "rates-direction-out"
}
const _hoisted_15 = { class: "col-md-12 col-lg-4" }
const _hoisted_16 = { class: "form-label text-capitalize-first" }
const _hoisted_17 = { class: "col-md-6 col-lg-3" }
const _hoisted_18 = { class: "form-label text-capitalize-first" }
const _hoisted_19 = { class: "col-md-6 col-lg-3" }
const _hoisted_20 = { class: "form-label text-capitalize-first" }
const _hoisted_21 = { class: "row mt-3" }
const _hoisted_22 = { class: "col-12" }
const _hoisted_23 = { class: "form-check" }
const _hoisted_24 = {
  class: "form-check-label",
  for: "rates-include-disabled"
}
const _hoisted_25 = { class: "text-muted small ms-1" }
const _hoisted_26 = { class: "small text-muted mt-2" }
const _hoisted_27 = { class: "card card-body" }
const _hoisted_28 = { class: "text-capitalize-first mb-3" }
const _hoisted_29 = { class: "row g-3" }
const _hoisted_30 = { class: "col-md-12 col-lg-4" }
const _hoisted_31 = { class: "form-label text-capitalize-first" }
const _hoisted_32 = {
  class: "btn-group btn-group-sm w-100",
  role: "group"
}
const _hoisted_33 = ["value"]
const _hoisted_34 = {
  class: "btn btn-outline-primary text-nowrap",
  for: "rates-target-fee"
}
const _hoisted_35 = ["value"]
const _hoisted_36 = {
  class: "btn btn-outline-primary text-nowrap",
  for: "rates-target-cut"
}
const _hoisted_37 = { class: "col-md-6 col-lg-3" }
const _hoisted_38 = { class: "form-label text-capitalize-first" }
const _hoisted_39 = { value: "" }
const _hoisted_40 = ["value"]
const _hoisted_41 = { class: "col-md-6 col-lg-2" }
const _hoisted_42 = { class: "form-label text-capitalize-first" }
const _hoisted_43 = ["min"]
const _hoisted_44 = { class: "col-md-12 col-lg-3 d-flex align-items-end justify-content-lg-end text-nowrap" }
const _hoisted_45 = {
  key: 0,
  class: "small text-muted mt-3"
}
const _hoisted_46 = { class: "small text-muted mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TrafficGroupMultiselect = _resolveComponent("TrafficGroupMultiselect")!
  const _component_TeamLeadMultiselect = _resolveComponent("TeamLeadMultiselect")!
  const _component_TraderMultiselect = _resolveComponent("TraderMultiselect")!
  const _component_TraderRatesBulkReportModal = _resolveComponent("TraderRatesBulkReportModal")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.lastResult)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", null, [
                  _cache[15] || (_cache[15] = _createElementVNode("i", { class: "fa fa-circle-check me-2" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('rates_management.last_operation', {changed: _ctx.lastResult.summary.changed, traders: _ctx.lastResult.summary.tradersChanged})) + " ", 1),
                  _createElementVNode("div", _hoisted_4, [
                    _createTextVNode(_toDisplayString(_ctx.helper.trans('rates_management.last_operation_id')) + " ", 1),
                    _createElementVNode("code", null, _toDisplayString(_ctx.lastResult.operationId), 1)
                  ])
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.lastResult = null))
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h6", _hoisted_6, _toDisplayString(_ctx.helper.trans('rates_management.selection')), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.helper.trans('rates_management.direction')), 1),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_10, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      class: "btn-check",
                      id: "rates-direction-in",
                      value: _ctx.Direction.PAY_IN,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.direction) = $event))
                    }, null, 8, _hoisted_11), [
                      [_vModelRadio, _ctx.form.direction]
                    ]),
                    _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.helper.trans('rates_management.direction_in')), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      class: "btn-check",
                      id: "rates-direction-out",
                      value: _ctx.Direction.PAY_OUT,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.direction) = $event))
                    }, null, 8, _hoisted_13), [
                      [_vModelRadio, _ctx.form.direction]
                    ]),
                    _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.helper.trans('rates_management.direction_out')), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.helper.trans('rates_management.traffic_groups')), 1),
                _createVNode(_component_TrafficGroupMultiselect, {
                  multiple: true,
                  small: "",
                  direction: _ctx.form.direction,
                  modelValue: _ctx.form.trafficGroups,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.trafficGroups) = $event))
                }, null, 8, ["direction", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.helper.trans('rates_management.team_leads')), 1),
                _createVNode(_component_TeamLeadMultiselect, {
                  multiple: true,
                  modelValue: _ctx.form.teamLeads,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.teamLeads) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.helper.trans('rates_management.traders')), 1),
                _createVNode(_component_TraderMultiselect, {
                  multiple: true,
                  modelValue: _ctx.form.traders,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.traders) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    id: "rates-include-disabled",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.includeDisabled) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.form.includeDisabled]
                  ]),
                  _createElementVNode("label", _hoisted_24, [
                    _createTextVNode(_toDisplayString(_ctx.helper.trans('rates_management.include_disabled')) + " ", 1),
                    _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.helper.trans('rates_management.include_disabled_hint')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _cache[16] || (_cache[16] = _createElementVNode("i", { class: "fa fa-circle-info me-1" }, null, -1)),
                  _createTextVNode(_toDisplayString(_ctx.helper.trans('rates_management.filters_hint')), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("h6", _hoisted_28, _toDisplayString(_ctx.helper.trans('rates_management.change')), 1),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.helper.trans('rates_management.target')), 1),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_32, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      class: "btn-check",
                      id: "rates-target-fee",
                      value: _ctx.TraderRatesBulkTarget.TRADER_FEE,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.target) = $event))
                    }, null, 8, _hoisted_33), [
                      [_vModelRadio, _ctx.form.target]
                    ]),
                    _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.helper.trans('rates_management.target_trader_fee')), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      class: "btn-check",
                      id: "rates-target-cut",
                      value: _ctx.TraderRatesBulkTarget.TEAM_LEAD_CUT,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.target) = $event))
                    }, null, 8, _hoisted_35), [
                      [_vModelRadio, _ctx.form.target]
                    ]),
                    _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.helper.trans('rates_management.target_team_lead_cut')), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.helper.trans('rates_management.mode')), 1),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.mode) = $event)),
                  class: "form-select form-select-sm"
                }, [
                  _createElementVNode("option", _hoisted_39, _toDisplayString(_ctx.helper.trans('rates_management.select_mode')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modes, (mode) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: mode.value,
                      value: mode.value
                    }, _toDisplayString(_ctx.helper.trans(mode.label)), 9, _hoisted_40))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.form.mode]
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.helper.trans('rates_management.value')), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  step: "0.001",
                  min: _ctx.valueMin,
                  max: "99.999",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.value) = $event)),
                  class: "form-control form-control-sm",
                  placeholder: "0.5"
                }, null, 8, _hoisted_43), [
                  [_vModelText, _ctx.form.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first me-2",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.reset()))
                }, _toDisplayString(_ctx.helper.trans('rates_management.reset')), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary btn-sm rounded-pill text-capitalize-first px-4",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.save()))
                }, _toDisplayString(_ctx.helper.trans('rates_management.save')), 1)
              ])
            ]),
            (_ctx.form.target === _ctx.TraderRatesBulkTarget.TEAM_LEAD_CUT)
              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                  _cache[17] || (_cache[17] = _createElementVNode("i", { class: "fa fa-circle-info me-1" }, null, -1)),
                  _createTextVNode(_toDisplayString(_ctx.helper.trans('rates_management.target_team_lead_cut_hint')), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_46, [
              _cache[18] || (_cache[18] = _createElementVNode("i", { class: "fa fa-shield-halved me-1" }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.helper.trans('rates_management.save_hint')), 1)
            ])
          ])
        ])
      ]),
      _createVNode(_component_TraderRatesBulkReportModal, {
        modelValue: _ctx.reportModal,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.reportModal) = $event)),
        report: _ctx.report,
        request: _ctx.submittedRequest,
        drift: _ctx.drift,
        applying: _ctx.applying,
        onConfirm: _cache[14] || (_cache[14] = ($event: any) => (_ctx.confirm()))
      }, null, 8, ["modelValue", "report", "request", "drift", "applying"])
    ]),
    _: 1
  }, 512))
}